import { render, staticRenderFns } from "./question-vise-stats.html?vue&type=template&id=739cf538&scoped=true&"
import script from "./question-vise-stats.vue?vue&type=script&lang=js&"
export * from "./question-vise-stats.vue?vue&type=script&lang=js&"
import style0 from "./question-vise-stats.css?vue&type=style&index=0&id=739cf538&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739cf538",
  null
  
)

export default component.exports